export default __webpack_public_path__ + "static/media/plastry.69f8ac10.svg";